import React from 'react';
import { Switch, Route } from 'react-router-dom';
import CurriculumList from './CurriculumsList';
import Builder from './Builder';
import Curricula from './Curricula';
import ViewExercise from 'modules/hc/curriculum/ViewExercise';
import { useSelector } from 'react-redux';

export default () => {
  const user = useSelector((s) => s.user.user);
  return (
    <Switch>
      <Route exact path="/curriculum" component={Curricula} />
      <Route
        exact
        path="/curriculum/:id/:moduleId?"
        component={CurriculumList}
      />
      <Route path="/curriculum/:moduleId/exercises/add" component={Builder} />
      <Route
        path="/curriculum/:moduleId/exercises/:id"
        component={user.type === 'admin' ? Builder : ViewExercise}
      />
    </Switch>
  );
};
